/**
 * Capitalizes the first letter of each word, delimited by spaces or hyphens.
 * @example
 * capitalize('cake') // Cake
 * capitalize('cake and pie') // Cake And Pie
 * capitalize('cake-and-pie') // Cake-And-Pie
 */
export function capitalize(str: string): string {
  return str.split(/([-\s]+)/)
    .map((wordOrDelimiter, index) => index % 2 === 1
      ? wordOrDelimiter
      : `${wordOrDelimiter[0].toUpperCase()}${wordOrDelimiter.slice(1)}`
    ).join('');
}